var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.375,
    cy: 12,
    r: 12,
    fill: "#E7B92A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3839 14.4061C11.8139 14.4061 11.3439 13.9595 11.3147 13.3903L10.9519 6.31513C10.9096 5.4911 11.5664 4.7998 12.3915 4.7998C13.2178 4.7998 13.875 5.49304 13.8309 6.3182L13.453 13.3925C13.4227 13.9608 12.953 14.4061 12.3839 14.4061ZM12.3931 19.3118C11.9141 19.3118 11.5173 19.1544 11.2026 18.8397C10.8878 18.525 10.7305 18.1487 10.7305 17.7108C10.7305 17.2729 10.8878 16.9034 11.2026 16.6024C11.5173 16.2876 11.9141 16.1302 12.3931 16.1302C12.872 16.1302 13.262 16.2876 13.5631 16.6024C13.8641 16.9034 14.0147 17.2729 14.0147 17.7108C14.0147 18.1487 13.8641 18.525 13.5631 18.8397C13.262 19.1544 12.872 19.3118 12.3931 19.3118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowAlert);
export default __webpack_public_path__ + "static/media/yellow_alert.b51624a452fa8e8ddcc48c9cf483cf6a.svg";
export { ForwardRef as ReactComponent };